<template>
  <div class="pupophHintOverlayer" @touchmove.prevent>
    <div class="pupophHint">
      <div class="pupophHintTop">
        <slot name="title"></slot>
        <!--<div class="title">确认驳回？</div>-->
      </div>
      <div class="pupophHintBottom">
        <span class="cancel" v-on:click="cancelHint">取消</span>
        <span class="sure" v-on:click="sureBtn">确认</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
      }
    },
    created(){
      // this.$store.state.bottomTabShow=false;
    },
    mounted(){
    },
    methods:{
      cancelHint(){
        var self=this;
        self.$emit('cancelPupopHint');
      },
      sureBtn(){
        var self=this;
        self.$emit('getBack');
      }
    },
    components: {
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .pupophHintOverlayer{
    position:fixed;
    left:0;
    top:0;
    width:100%;
    height:100%;
    z-index:10;
    background-color: rgba(0, 0, 0, .5);
  }
  .pupophHint{
    width: 5.4rem;
    /*height: 2.3rem;*/
    background-color: #ffffff;
    margin: 58% auto 0;
    border-radius: 8px;
    /*padding: 0.54rem 0 0.46rem;*/
    .pupophHintTop{
      width: 100%;
      /*height: 1.4rem;*/
      padding: 0.54rem 0 0.4rem;
      .title{
        width: 100%;
        font-size: 0.34rem;
        text-align: center;
      }
    }
    .pupophHintBottom{
      width: 100%;
      height: 0.94rem;
      border-top: 1px #dfdfdf solid;
      .cancel,.sure{
        display: inline-block;
        width: 49%;
        height: 100%;
        color: #00c4b6;
        font-size: 0.3rem;
        line-height: 0.94rem;
        text-align: center;
      }

      .cancel{
        border-right: 1px #dfdfdf solid;
      }
    }
  }
  .pupopOver .pdBt{
    padding-bottom: 1.2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/pupopHint.vue?4505d4c8